module.exports = __webpack_public_path__ + "img/2010 winteressen 019.4abcdaf1.jpg";